var exports = {
  "kL": "BaseAvatar.module__container___TlZqTE",
  "vk": "BaseAvatar.module__clickable___TlZqTE",
  "Lw": "BaseAvatar.module__overlay___TlZqTE",
  "Sl": "BaseAvatar.module__image___TlZqTE",
  "qf": "BaseAvatar.module__placeholder___TlZqTE",
  "ci": "BaseAvatar.module__placeholderFastFade___TlZqTE",
  "Ap": "BaseAvatar.module__placeholderVisible___TlZqTE",
  "uR": "BaseAvatar.module__placeholderHidden___TlZqTE",
  "n_": "BaseAvatar.module__hoverOverlay___TlZqTE",
  "II": "BaseAvatar.module__statusContainer___TlZqTE",
  "mH": "BaseAvatar.module__statusTooltipDisabled___TlZqTE",
  "VN": "BaseAvatar.module__reducedMotion___TlZqTE",
  "BC": "BaseAvatar.module__animatedMaskShape___TlZqTE",
  "Qb": "BaseAvatar.module__animatedMaskReducedMotion___TlZqTE",
  "AP": "BaseAvatar.module__typingBubble___TlZqTE",
  "y5": "BaseAvatar.module__typingDots___TlZqTE",
  "BI": "BaseAvatar.module__typingDot___TlZqTE",
  "Zm": "BaseAvatar.module__blink___TlZqTE",
  "fQ": "BaseAvatar.module__customStatusBadge___TlZqTE",
  "Bp": "BaseAvatar.module__customStatusBadgeBackground___TlZqTE",
  "Go": "BaseAvatar.module__customStatusBadgeContent___TlZqTE",
};

module.exports = exports;
